import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Aside from "src/app/components/Aside/Aside";
import AsideSearch from "src/app/components/AsideSearch/AsideSearch";
import Card from "src/app/components/Card/Card";
import GetInTouch from "src/app/components/GetInTouch/GetInTouch";
import FaqContent from "src/app/layouts/FaqListing/FaqContent";
import HelpTopics from "src/app/components/HelpTopics/HelpTopics";
import Main from "src/app/components/Main/Main";
import ViewRelatedQuestions from "src/app/components/ViewRelatedQuestions/ViewRelatedQuestions";

const FaqListing = ({ content = {}, storeData = {}, faqItems = {} }) => {
  const [previewing, setPreviewing] = useState(false);

  const {
    analytics,
    aside: {
      "popular-articles": popularArticles = [],
      topics,
      "search-box": searchBox,
      "get-in-touch": getInTouch,
    },
  } = content;

  const popularArticlesElements = popularArticles.elements || [];

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    if (window.__INITIAL_STATE__.previewing) {
      setPreviewing(true);
    }
  }, []);

  return (
    <>
      <Main>
        <FaqContent
          content={content}
          faqItems={faqItems}
          storeData={storeData}
        />
        {faqItems.error &&
          !previewing &&
          popularArticlesElements[0]?.articles?.length > 0 && (
            <Card type="bottom" ariaLive="polite" ariaRelevant="additions text">
              <ViewRelatedQuestions
                data={popularArticlesElements[0]}
                button={popularArticlesElements[0]["faq-list"]}
                analytics={analytics}
              />
            </Card>
          )}
      </Main>
      <Aside>
        {topics?.elements?.length > 0 && (
          <Card type="aside">
            <HelpTopics data={topics} />
          </Card>
        )}
        {searchBox?.elements?.length > 0 && (
          <Card type="aside">
            <AsideSearch data={searchBox.elements[0]} />
          </Card>
        )}
        {getInTouch?.elements?.length > 0 && (
          <Card type="aside" data-id="getInTouch">
            <GetInTouch data={getInTouch.elements[0]} />
          </Card>
        )}
      </Aside>
    </>
  );
};

FaqListing.defaultName = "FaqListing";

export default FaqListing;

FaqListing.propTypes = {
  content: PropTypes.object,
  storeData: PropTypes.object,
  faqItems: PropTypes.object,
};
